/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import TableHeader from 'components/Table/TableHeader';

// Material Dashboard 2 PRO React examples
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import Iframe from 'react-iframe';

const initFind = {
  search: '',
  order_by: 'l.barcode_id',
  order_sort: 'asc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  supplier: 0,
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
};

function RpConsignmentSale() {
  const mod = 'rp_consignment_sale';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [find, setFind] = useState(initFind);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [cboSupplier, setCboSupplier] = useState([]);
  const [cboMonth, setCboMonth] = useState([]);
  const [cboYear, setCboYear] = useState([]);
  const [urlExcel, setUrlExcel] = useState('');
  const [urlPrint, setUrlPrint] = useState('');
  const [modalPrint, setModalPrint] = useState(false);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'l.barcode_id', label: t(`attr.image`), align: 'center', width: 40 },
    { id: 'l.name', label: 'สินค้า', align: 'left' },
    { id: 'l.cost_fix', label: 'ราคาทุน', align: 'right' },
    { id: 'b.quantity_remain', label: 'ยอดตั้งต้น', align: 'right' },
    { id: 'rc.recieve_qty', label: 'ยอดส่งเพิ่ม', align: 'right' },
    { id: 'rt.return_qty', label: 'คืนผู้จัดจำหน่าย', align: 'right' },
    { id: 'l.total_sale_qty', label: 'จำนวนขาย', align: 'right' },
    { id: '1', label: 'ยอดขาย', align: 'right', sort: false },
    { id: '2', label: 'คงเหลือฝาก', align: 'right', sort: false },
    { id: '3', label: 'ยอดคงเหลือฝาก', align: 'right', sort: false },
  ];

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      supplier: data.supplier,
      date_start: `${data.year}-${data.month - 1}-26 00:00:00`,
      date_stop: `${data.year}-${data.month}-25 23:59:59`,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
        setPageTotal(result.total_pages);
        setPageNo(result.page);
        // setSummary(result.summary);
      }
      setLoading(false);
    });
  };

  const excel = () => {
    let param = `download`;
    param += `?search=${find.search}`;
    param += `&supplier=${find.supplier}`;
    param += `&date_start=${find.year}-${find.month - 1}-26 00:00:00`;
    param += `&date_stop=${find.year}-${find.month}-25 23:59:59`;

    window.open(`${urlExcel}/${param}`, '_self');
    // window.open(`${urlExcel}/${param}`, "_blank");
  };

  const renderPrint = () => {
    return (
      <Dialog
        open={modalPrint}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-print'
        fullScreen
        onClose={() => setModalPrint(false)}
      >
        <DialogTitle>
          # &nbsp;
          {`${cboSupplier.find((item) => item.id === find.supplier)?.name} ${find.month}/${
            find.year
          }`}
          <IconButton
            aria-label='close'
            onClick={() => setModalPrint(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {record.length === 0 ? null : (
            <Iframe
              url={urlPrint}
              width='100%'
              height='100%'
              id='print'
              className=''
              display='initial'
              position='relative'
              frameBorder='0'
            />
          )}
        </DialogContent>
      </Dialog>
    );
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const print = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/print`, app.token, {
      supplier: find.supplier,
      date_start: `${find.year}-${find.month - 1}-26 00:00:00`,
      date_stop: `${find.year}-${find.month}-25 23:59:59`,
      lang: app.lang,
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setUrlPrint(result.print);
        setModalPrint(true);
      }
    });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setCboSupplier(result.supplier);
        setCboMonth(result.months);
        setCboYear(result.years);
        setUrlExcel(result.excel);
        view(initFind);
      } else {
        Func.exitApp();
      }
    });
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              fullWidth
              value={find.supplier}
              select
              onChange={(e) => view({ ...find, supplier: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.supplier')} :</InputAdornment>
                ),
              }}
            >
              {cboSupplier.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={2}>
            <MDInput
              fullWidth
              value={find.month}
              select
              onChange={(e) => view({ ...find, month: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.month')} :</InputAdornment>
                ),
              }}
            >
              {cboMonth.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={2}>
            <MDInput
              fullWidth
              value={find.year}
              select
              onChange={(e) => view({ ...find, year: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('menu.year')} :</InputAdornment>
                ),
              }}
            >
              {cboYear.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          {record.length > 0 && (
            <>
              <Grid item xs={12} sm={12} md={12} lg={1}>
                <MDBox display='flex' justifyContent='end' gap={1}>
                  <MDButton variant='gradient' color='success' onClick={excel}>
                    <i className='fal fa-file-spreadsheet' /> &nbsp; Excel
                  </MDButton>
                </MDBox>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={1}>
                <MDBox display='flex' justifyContent='end' gap={1}>
                  <MDButton variant='gradient' color='info' onClick={print}>
                    <Icon>print</Icon> &nbsp; Print
                  </MDButton>
                </MDBox>
              </Grid>
            </>
          )}
        </Grid>
      </Card>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant='contained'
              color='dark'
              size='large'
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              href='/report_purchase'
            >
              <Icon>content_paste_search</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={initHeader.length} align='center'>
                        <MDBox>ไม่พบข้อมูลกรุณาเลือกผู้จัดจำหน่าย</MDBox>
                      </TableCell>
                    </TableRow>
                  ) : (
                    record.map((row) => (
                      <TableRow key={row.id} hover>
                        <TableCell>{Func.imageDisplay(row)}</TableCell>
                        <TableCell align='left'>
                          <MDBox className='nowrap'>
                            {row.code} <span className='color-default'>{row.barcode}</span>
                          </MDBox>
                          <MDBox className='cut' width={200}>
                            {row.name}
                          </MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap'>
                          <MDBox className='nowrap'>{Func.numberDisplay(row.cost_fix, 2)}</MDBox>
                          <MDBox className='nowrap'>บาท</MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap'>
                          <MDBox className='nowrap'>
                            {Func.numberDisplay(row.quantity_remain)}
                          </MDBox>
                          <MDBox className='nowrap'>{row.unit_name}</MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap'>
                          <MDBox className='nowrap'>{Func.numberDisplay(row.recieve_qty)}</MDBox>
                          <MDBox className='nowrap'>{row.unit_name}</MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap'>
                          <MDBox className='nowrap'>{Func.numberDisplay(row.return_qty)}</MDBox>
                          <MDBox className='nowrap'>{row.unit_name}</MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap'>
                          <MDBox className='nowrap'>{Func.numberDisplay(row.total_sale_qty)}</MDBox>
                          <MDBox className='nowrap'>{row.unit_name}</MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap highlight-success'>
                          <MDBox className='nowrap'>
                            {Func.numberDisplay(row.total_sale_amount, 2)}
                          </MDBox>
                          <MDBox className='nowrap'>บาท</MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap'>
                          <MDBox className='nowrap'>
                            {Func.numberDisplay(row.remain_consignment_qty)}
                          </MDBox>
                          <MDBox className='nowrap'>{row.unit_name}</MDBox>
                        </TableCell>
                        <TableCell align='right' className='nowrap'>
                          <MDBox className='nowrap'>
                            {Func.numberDisplay(row.remain_consignment_amount, 2)}
                          </MDBox>
                          <MDBox className='nowrap'>บาท</MDBox>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                  {/* <TableRow>
                    <TableCell align='right' colSpan={6}>
                      รวม
                    </TableCell>
                    <TableCell align='right'>
                      {Func.numberDisplay(summary.quantity_receive)}
                    </TableCell>
                    <TableCell align='right'>{Func.numberDisplay(summary.quantity_free)}</TableCell>
                    <TableCell />
                    <TableCell align='right' className='highlight-success'>
                      {Func.numberDisplay(summary.amount)}
                    </TableCell>
                    <TableCell />
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <MDBox>
      <Navbar route={[t(`menu.report_purchase`), t(`menu.rp_consignment_sale`)]} />
      {renderList()}
      {renderPrint()}
      {renderLoading()}
    </MDBox>
  );
}

export default RpConsignmentSale;
